import type { SidebarMenuItem } from "@shared/types/sidebarMenu";

export function collectNavigableLeafPaths(item: SidebarMenuItem, out: string[] = []): string[] {
    if (item.type === "page" && item.path) out.push(item.path);
    for (const child of item.children ?? []) collectNavigableLeafPaths(child, out);
    return out;
}

export function findFirstNavigableLeafPath(item: SidebarMenuItem): string | undefined {
    if (item.type === "page" && item.path) return item.path;
    for (const child of item.children ?? []) {
        const nested = findFirstNavigableLeafPath(child);
        if (nested) return nested;
    }
    return undefined;
}

export function collectVisiblePages(item: SidebarMenuItem): SidebarMenuItem[] {
    if (item.type === "page") return item.path ? [item] : [];
    return (item.children ?? []).flatMap(collectVisiblePages);
}
